import { MutationTree } from 'vuex';
import Vue from 'vue';

import {
    IAppConfigState,
    APP_CONFIG_MODULE_TYPES
} from './app-config-types.store';

export const mutations: MutationTree<IAppConfigState> = {
    [APP_CONFIG_MODULE_TYPES.GET_FORM_DATA_CONFIG_BY_TYPE]: (state, payload: {key: string, value: any}) => {
        Vue.set(state.formDataConfigs, payload.key, payload.value);
    },
    [APP_CONFIG_MODULE_TYPES.SET_SYSTEM_CONFIG]: (state, payload: {key: string, value: any}) => {
        Vue.set(state.systemAppConfigs, payload.key, payload.value);
    },
    [APP_CONFIG_MODULE_TYPES.SET_USER_CONFIG]: (state, payload: {key: string, value: any}) => {
        Vue.set(state.userAppConfigs, payload.key, payload.value);
    },
    [APP_CONFIG_MODULE_TYPES.UPDATE_CONFIG_VALUE]: (state, payload: {key: string, value: any}) => {
        if (state.systemAppConfigs.hasOwnProperty(payload.key)) {
            Vue.set(state.systemAppConfigs, payload.key, payload.value);
        }
        
        if (state.userAppConfigs.hasOwnProperty(payload.key)) {
            Vue.set(state.userAppConfigs, payload.key, payload.value);
        }
        
        for (let moduleKey in state.formDataConfigs) {
            const configs = state.formDataConfigs[moduleKey];
            if (configs && configs.hasOwnProperty(payload.key)) {
                Vue.set(state.formDataConfigs[moduleKey], payload.key, payload.value);
                return;
            }
        }
        console.warn(`Config key "${payload.key}" not found in any config store`);
    },
}